import React, {SyntheticEvent, useContext, useState} from "react";
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import {TextdomainContext} from 'react-gettext';

import ntnuLogo from "../images/NTNU_bareLogo.png";

const Students: React.FC = () => {
    const { gettext } = useContext(TextdomainContext);
    const [expanded, setExpanded] = useState<string | false>(false);

    const handleChange = (panel: string) => (event: SyntheticEvent, isExpanded: boolean) => {
          setExpanded(isExpanded ? panel : false);
    };

    return (
        <Container maxWidth="md">
            <Accordion
              expanded={expanded === 'ntnu'}
              onChange={handleChange('ntnu')}
            >
                <AccordionSummary
                    id="ntnu"
                    expandIcon={<ExpandMoreIcon />}
                >
                    <Typography variant="body1">
                        <img src={ntnuLogo} height="50px" alt="NTNU logo"/>
                        {' '}
                        NTNU MH {gettext('Tilgang for studenter ved profesjonsstudiet i medisin')}
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography variant="body2">
                        {`${gettext('Dette er studenters tilgang til publiserte oppgaver i FVO basen og gjelder bare studenter på profesjonsstudiet i medisin ved NTNU')}.
${gettext('Trening på tidligere eksamener og formativ testing foregår fra samme sted')}.`}
                    </Typography>
                    <br />
                    <Typography variant="body2">
                        <a href="https://mcq.medisin.ntnu.no/progress/">https://mcq.medisin.ntnu.no/progress/</a>

                        {gettext('Manglende tilgang og feil/problemer kan meldes inn ved å registrere en jobb på')}
                    </Typography>
                    <br />
                    <Typography variant="body2">
                        <a href="https://hjelp.ntnu.no">hjelp.ntnu.no</a>
                    </Typography>
                </AccordionDetails>
            </Accordion>
        </Container>
    );
};

export default Students;
